import React from 'react';
import ReactDOM from 'react-dom';
import { Button } from '@cgn/framework-ui-components/v1';
import classname from 'classnames';

var div = document.createElement('div');
document.body.appendChild(div);

class Tour extends React.Component {
  state = {
    slide: this.props.slide
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next.slide != this.state.slide) {
      this.setState({ slide: next.slide })
    }
  }

  saveState(slide) {
    this.props.onChange(slide);
  }

  dietro = () => {
    var prev = this.state.slide - 1;
    this.saveState(prev);
    this.setState({ slide: prev });
  }

  avanti = () => {
    var next = this.state.slide + 1;
    this.saveState(next);
    this.setState({ slide: next })
  }

  chiudi() {
    this.props.onEnd(false);
  }

  render() {
    return ReactDOM.createPortal(
      <div className="tour" >
        <div className="tour__overlay" onClick={() => this.chiudi()}>
          <div className="tour__container" onClick={e => e.stopPropagation()}>
            <ul className="tour__slideList">
              {this.props.slides.map((x, i) => {
                var classes = classname('tour__slide', { 'tour__slide--active': i == this.state.slide });
                return <li key={i} className={classes}><img src={x} /></li>
              })}
            </ul>
            <div className="tour__containerControlli">
              {this.state.slide > 0 && <Button onClick={this.dietro}>Indietro</Button>}
              {this.state.slide < this.props.slides.length - 1 && <Button onClick={this.avanti} primary>Avanti</Button>}
              {this.state.slide == this.props.slides.length - 1 && <Button onClick={() => this.props.onEnd(true)} primary>Fine</Button>}
            </div>
          </div>

        </div>
      </div>,
      div,
    );
  }
}

export default Tour;